<div class="sidebar-layout">
  <div class="sidebar-layout-header">
    <ebw-monorepo-sidebar-header [icon]="'cloud_upload'" [title]="'map.sidebar.trasmissione_antea.title'"
      [isSvg]="false" [isOutline]="false">
    </ebw-monorepo-sidebar-header>
  </div>

  <ng-container *ngIf="token$ | async as token; else notAuthenticated">
    <mat-tab-group class="sezione-tabs">
      <mat-tab label="{{ 'map.sidebar.trasmissione_antea.tab_controlli' | translate }}">
        <div class="parent-div mt-2">
          <mat-tab-group animationDuration="0ms">
            <mat-tab label="Prelievi">
              <div class="mt-4">
                <ebw-monorepo-trasmissione-antea-sezione [tipo]="'prelievi'"></ebw-monorepo-trasmissione-antea-sezione>
              </div>
            </mat-tab>
            <mat-tab label="Superamenti Reportnet3">
              <div class="mt-4">
                <ebw-monorepo-trasmissione-antea-sezione [tipo]="'superamenti'"></ebw-monorepo-trasmissione-antea-sezione>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-tab>
      <mat-tab label="{{ 'map.sidebar.trasmissione_antea.tab_psa' | translate }}">
        <div class="parent-div mt-2">
          <div class="placeholder">Sezione in arrivo</div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>

  <ng-template #notAuthenticated>
    <div class="placeholder">
      <p>{{ 'map.sidebar.trasmissione_antea.title' | translate }} — accesso richiesto</p>
      <button mat-flat-button color="primary" (click)="openCredentialsDialog()">
        {{ 'map.sidebar.trasmissione_antea.credentials_dialog.login' | translate }}
      </button>
    </div>
  </ng-template>
</div>
